module.exports = __webpack_public_path__ + "media/components/assets/images/cooingklePackage/image2_2-04df99bdc3f4ce848e2dbef40994d164.png";